"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStopScreenScroll = exports.useMoveFocusToTheComponent = exports.focusComponentElementHandler = exports.useHandleEscapeBtn = exports.handleEscapeBtn = exports.useTrapFocus = exports.handleTab = exports.trapFocus = exports.isTouchDevice = exports.compact = exports.deprecate = exports.getStoryBookBasePath = void 0;
const react_1 = require("react");
const getStoryBookBasePath = () => {
    return process.env.STORYBOOK_ENV === 'production'
        ? '/component-library/index.html'
        : '/';
};
exports.getStoryBookBasePath = getStoryBookBasePath;
const deprecate = (component, msg) => {
    const isProd = 'production' === process.env.NODE_ENV;
    if (!isProd) {
        console.warn(msg);
    }
    return component;
};
exports.deprecate = deprecate;
function compact(object) {
    const clone = Object.assign({}, object);
    for (const key in clone) {
        if (clone[key] === undefined)
            delete clone[key];
    }
    return clone;
}
exports.compact = compact;
const isTouchDevice = () => !!(typeof window !== 'undefined' && 'ontouchstart' in window) ||
    !!(typeof navigator !== 'undefined' &&
        (navigator.maxTouchPoints ||
            navigator
                .msMaxTouchPoints));
exports.isTouchDevice = isTouchDevice;
const FOCUSABLE_HTML_ELEMENTS = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex^="-"])'
];
const FOCUSABLE_HTML_ELEMENTS_SELECTOR = FOCUSABLE_HTML_ELEMENTS.join(', ');
function trapFocus(root, event) {
    const focusableElements = Array.from(root.querySelectorAll(FOCUSABLE_HTML_ELEMENTS_SELECTOR));
    if (focusableElements.length > 0) {
        const filteredElements = [], selectedGroups = [];
        focusableElements.forEach(el => {
            const { type, name } = el;
            if (type !== 'radio') {
                filteredElements.push(el);
            }
            else {
                if (name && selectedGroups.indexOf(name) < 0) {
                    const group = root.querySelectorAll(`input[type="${type}"][name="${name}"]`);
                    if (group.length > 1) {
                        filteredElements.push(root.querySelector(`input[type="${type}"][name="${name}"]:checked`) || group[0]);
                        selectedGroups.push(name);
                    }
                    else {
                        filteredElements.push(el);
                    }
                }
            }
        });
        const firstElement = filteredElements[0], lastElement = filteredElements[filteredElements.length - 1];
        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        }
        else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    }
}
exports.trapFocus = trapFocus;
function handleTab(mountNodeRef) {
    return (e) => {
        if (mountNodeRef.current && (e.keyCode === 9 || e.key === 'Tab')) {
            trapFocus(mountNodeRef.current, e);
        }
    };
}
exports.handleTab = handleTab;
function useTrapFocus(mountNodeRef) {
    react_1.useEffect(() => {
        const handler = handleTab(mountNodeRef);
        window.addEventListener('keydown', handler);
        return () => {
            window.removeEventListener('keydown', handler);
        };
    }, [mountNodeRef]);
}
exports.useTrapFocus = useTrapFocus;
function handleEscapeBtn(onClose) {
    return (e) => {
        if (onClose && (e.keyCode === 27 || e.key === 'Escape')) {
            onClose();
        }
    };
}
exports.handleEscapeBtn = handleEscapeBtn;
function useHandleEscapeBtn(onClose) {
    react_1.useEffect(() => {
        const handler = handleEscapeBtn(onClose);
        window.addEventListener('keyup', handler);
        return () => {
            window.removeEventListener('keyup', handler);
        };
    }, [onClose]);
}
exports.useHandleEscapeBtn = useHandleEscapeBtn;
function focusComponentElementHandler(mountNodeRef, elementSelector) {
    if (mountNodeRef.current) {
        const elementToFocus = mountNodeRef.current.querySelector(elementSelector || FOCUSABLE_HTML_ELEMENTS_SELECTOR);
        if (elementToFocus) {
            elementToFocus.focus();
        }
    }
}
exports.focusComponentElementHandler = focusComponentElementHandler;
function useMoveFocusToTheComponent(mountNodeRef, elementToFocusOnModalOpen) {
    react_1.useEffect(() => {
        focusComponentElementHandler(mountNodeRef, elementToFocusOnModalOpen);
    }, [mountNodeRef]);
}
exports.useMoveFocusToTheComponent = useMoveFocusToTheComponent;
function useStopScreenScroll() {
    react_1.useEffect(() => {
        const body = document.body;
        body.style.overflow = 'hidden';
        return () => {
            body.style.overflow = '';
        };
    }, []);
}
exports.useStopScreenScroll = useStopScreenScroll;
